import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./scss/po.scss";
import { warningSnackBar, successSnackBar } from "../../../actions/common.action";
import { PURCHASE_ORDER, SUPPLIERS } from "../../../constants/route-paths";
import {
  getProjectList,
  savePurchaseOrder,
  editPurchaseOrder,
  getProject,
  getPurchaseOrder,
} from "../../../actions/project-management.action";
import { getVendorList } from "../../../actions/vendor-management.action";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useParams } from "react-router";
import CreatePOComponent from '../../../components/po/create';
import { history } from "../../../util/history";
import { getGlobalSetting } from "../../../actions/global-setting.action";
import { getCustomerSiteAddress } from "../../../actions/customer-management.action";
import { getInventoryLists } from "../../../actions/inventory.action";

function CreatePurchaseOrder(props) {

  const { poId } = useParams();

  const cancelHandler = () => {
    // Use custom cancel handler if provided, otherwise use default
    if (props.customCancelHandler) props.customCancelHandler();
    else history.navigate(`/${SUPPLIERS}/${PURCHASE_ORDER}`);
  };

  return (
    <>
      <CreatePOComponent
        breadcrumb={
          <Breadcrumb>
            <Breadcrumb.Item onClick={cancelHandler}>PO</Breadcrumb.Item>
            <Breadcrumb.Item active>{poId ? "Edit PO" : "Create PO"}</Breadcrumb.Item>
          </Breadcrumb>
        }
        cancelHandler={cancelHandler}
        warningSnackBar={props.warningSnackBar}
        successSnackBar={props.successSnackBar}
        getProjectList={props.getProjectList}
        savePurchaseOrder={props.savePurchaseOrder}
        editPurchaseOrder={props.editPurchaseOrder}
        getVendorList={props.getVendorList}
        getProject={props.getProject}
        getPurchaseOrder={props.getPurchaseOrder}
        getGlobalSetting={props.getGlobalSetting}
        getCustomerSiteAddress={props.getCustomerSiteAddress}
        getInventoryItems={props.getInventoryLists}
      />
    </>
  );

}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
  successSnackBar: bindActionCreators(successSnackBar, dispatch),
  getProjectList: bindActionCreators(getProjectList, dispatch),
  savePurchaseOrder: bindActionCreators(savePurchaseOrder, dispatch),
  editPurchaseOrder: bindActionCreators(editPurchaseOrder, dispatch),
  getVendorList: bindActionCreators(getVendorList, dispatch),
  getProject: bindActionCreators(getProject, dispatch),
  getPurchaseOrder: bindActionCreators(getPurchaseOrder, dispatch),
  getGlobalSetting: bindActionCreators(getGlobalSetting, dispatch),
  getCustomerSiteAddress: bindActionCreators(getCustomerSiteAddress, dispatch),
  getInventoryLists: bindActionCreators(getInventoryLists, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePurchaseOrder);
